import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';
// Helpers
import { handleSwitchInputKeys } from '../../helpers/helpers.js'

const ProctoringInfo = observer(class RegisterStep02 extends React.Component {
  componentWillMount() {
    // Get enabled proctor types
    this.props.store.SessionStore.getFilteredProctorTypes();
  }

  render() {
    const { SessionStore } = this.props.store;
    const { translation } = this.props;

    function subCategoryLength(subCategories) {
      let enabledSubcategories = subCategories.filter(function(subCategory){
        return subCategory.status !== 'disabled' && subCategory.allowSelfSelection === true;
      });

      if (enabledSubcategories.length > 0) {
        return true;
      }

      return false;
    }

    return (
      <form className="panel" onSubmit={(e) => this.props.checkValidity(e, this.props.handleSubmit(e))} noValidate>
        <div className="panel__header">
          <h3 className="panel__title"><legend>{translation.heading}</legend></h3>
        </div>

        <fieldset className="panel__body">
          {/* <h4 className="form-heading">{translation.languages.heading}</h4>

          <ul className="switch-list">
            {
              Object
                .keys(translation.languages.options)
                .map(
                (key) =>
                  <li key={key}>
                    <label htmlFor={`register-language-${key}`}>{translation.languages.options[key].label}</label>
                    <input type="checkbox"
                      id={`register-language-${key}`}
                      name="languages[]"
                      className="switch-input"
                      checked={this.props.accountData.languages.indexOf(key) !== -1 ? true : false}
                      onChange={e => this.props.handleToggle(e, "languages", key)} />
                    <label className="switch-label" htmlFor={`register-language-${key}`}><span className="meta">{translation.languages.options[key].label}</span></label>
                  </li>
                )
            }
          </ul> */}

          <h4 className="form-heading">
            {translation.proctor_type.heading}
            <div className="tooltip">
              <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
              <div id="proctor-type-tooltip" className="tooltip__body" role="tooltip">{translation.proctor_type.tooltip}</div>
            </div>
          </h4>

          {SessionStore.proctorTypeList.map(
            (key, i) =>
            {
              if(subCategoryLength(key.subCategories)) {
                return (
                  <div className="form-subgroup" key={i}>
                    <strong className="form-subheading">{key.title}</strong>

                    {subCategoryLength(key.subCategories)}

                    <ul className="switch-list">
                      {key.subCategories.filter(function(obj){
                        return obj.allowSelfSelection;
                      }).map(
                        (subKey, j) =>
                          {
                            if(subKey.status === 'disabled') {
                              // Return nothing if this type is disabled
                              return '';
                            } else {
                              // Otherwise return a switch field
                              return (
                                <li key={j}>
                                  <label htmlFor={`register-type${i}-${j}`}>{subKey.title}</label>

                                  <input
                                    type="checkbox"
                                    id={`register-type${i}-${j}`}
                                    name="languages[]"
                                    className="switch-input"
                                    defaultChecked={this.props.accountData.proctorTypes.indexOf(subKey.sid) !== -1 ? true : false}
                                    onChange={e => this.props.handleToggle(e, "proctorTypes", subKey.sid)}
                                    onKeyDown={handleSwitchInputKeys}
                                  />

                                  <label className="switch-label" htmlFor={`register-type${i}-${j}`}><span className="meta">{subKey.title}</span></label>
                                </li>
                              )
                            }
                          }
                      )}
                    </ul>
                  </div>
                )
              }

              return '';
            }
          )}

          {/* <ul className="switch-list">
            {
              Object
                .keys(translation.proctor_type.options)
                .map(
                  (key) =>
                  <li key={key}>
                    <label htmlFor={`register-type-${key}`}>{translation.proctor_type.options[key].label}</label>
                    <input type="checkbox" id={`register-type-${key}`} name="languages[]" className="switch-input" value={key} />
                    <label className="switch-label" htmlFor={`register-type-${key}`}><span className="meta">{translation.proctor_type.options[key].label}</span></label>
                  </li>
                )
            }
          </ul> */}

          <div className="panel__actions actions">
            <button className="actions__btn actions__btn--secondary" onClick={this.props.prevStep} type="button">{translation.back}</button>
            <button className="actions__btn actions__btn--primary" type="submit">{translation.button}</button>
          </div>
        </fieldset>
      </form>
    )
  }
})

export default translate('ProctoringInfo')(ProctoringInfo);


// WEBPACK FOOTER //
// ./src/app/components/Register/ProctoringInfo.js